import { useMemo } from 'react';
import _ from 'lodash';
import { Modal } from './design-system/Modal';
import { formatRewardsType } from '../data/shared/utils/formatRewardsType';
import { EditableTableCell } from './design-system/EditableTableCell';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CreditCardRewardsType } from 'data/shared/CreditCardRewardsTypes';
import { CreditCard } from 'data/shared/CreditCard';
import { CreditCardData } from 'data/shared/CreditCardData';

export const EditPointValues = ({
  handleClose,
  cards,
  pointValues,
  resetPointValues,
  setPointValues,
}: {
  cards: CreditCard[];
  pointValues: Record<CreditCardRewardsType, number>;
  setPointValues: (rewardsType: CreditCardRewardsType, value: string) => void;
  resetPointValues: (_?: CreditCardRewardsType) => void;
  handleClose: () => void;
}) => {
  const pointValuesToShow: CreditCardRewardsType[] = useMemo(
    () => _.uniq(cards.map((card) => CreditCardData[card].rewardsType)).sort(),
    [cards]
  );

  return (
    <Modal isOpen={true} handleClose={handleClose}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h1>Edit Point Values</h1>
        <button onClick={() => resetPointValues()}>
          <FontAwesomeIcon icon={faRefresh} /> Reset
        </button>
      </div>
      {pointValuesToShow.map((rewardsType) => (
        <div
          key={rewardsType}
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <label style={{ marginRight: 5 }}>
            {formatRewardsType(rewardsType)}
          </label>
            {rewardsType === CreditCardRewardsType.CASH_BACK ? (
            <strong>1</strong>
          ) : (
            <EditableTableCell
              value={String(pointValues[rewardsType])}
              onChange={(value) => setPointValues(rewardsType, value)}
            />
          )}
          <span style={{ marginLeft: 5 }}>cent(s) per point</span>
        </div>
      ))}
    </Modal>
  );
};
